import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For PostHog to work optimally, we store a small amount of information about the user on the user's browser. This ensures we identify users properly if they navigate away from your site and come back later. `}</p>
    <p>{`The information we store includes:`}</p>
    <ul>
      <li parentName="ul">{`Their `}<inlineCode parentName="li">{`distinct_id`}</inlineCode></li>
      <li parentName="ul">{`Session ID & Device ID`}</li>
      <li parentName="ul">{`Active & enabled feature flags`}</li>
      <li parentName="ul">{`Any super properties you have defined`}</li>
      <li parentName="ul">{`Some PostHog configuration options (e.g. whether session recording is enabled)`}</li>
    </ul>
    <p>{`By default, we store all this information in both a `}<inlineCode parentName="p">{`cookie`}</inlineCode>{` and `}<inlineCode parentName="p">{`localStorage`}</inlineCode>{`, which means PostHog can identify your users across subdomains. By default, the name of the cookie PostHog sets is `}<inlineCode parentName="p">{`ph_<project_api_key>_posthog`}</inlineCode>{` and it expires after `}<inlineCode parentName="p">{`365`}</inlineCode>{` days. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      